import { deleteRequest } from '@/core';

export default async function deleteModuleData(moduleName) {
	let url = `/${moduleName}/`;
	try {
		let response = await deleteRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}